import { combineReducers } from "redux";

import counter from "../features/admin/homepage/counter/Slice";

import socialmedia from "../features/admin/homepage/socialmedia/Slice";

import common from "../features/admin/common/Slice";

const homepage = combineReducers({
    counter,
    socialmedia,
    common
});

export default homepage;